import { action, makeObservable, observable } from 'mobx';

class SidebarStore {

  isOpen = false;

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      setIsOpen: action,
    });
  }

  setIsOpen = (isOpen: boolean) => {
    this.isOpen = isOpen;
  }

}

export const sidebarStore = new SidebarStore();
